function i() {
  return "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white focus-visible:ring-2 focus-visible:ring-blue-600";
}
export {
  i as getAccessibleFocusStyles
};
